<template>
  <div class="app-container">
    <el-card class="operate-container" shadow="never">
      <i class="el-icon-tickets"></i>
      <span>投稿记录</span>
      <el-button size="mini" class="btn-add" @click="handleLogOut()" style="float:right;margin-left:20px">退出</el-button>
      <el-button size="mini" class="btn-add" @click="handleAdd()" style="float:right">我要投稿</el-button>
  
    </el-card>
    <div class="table-container">
      <el-table ref="adminTable" :data="list" style="width: 100%;" v-loading="listLoading" border>
        <el-table-column label="序号" align="center">
          <template
            slot-scope="scope"
          >{{(listQuery.pageNum - 1) * listQuery.pageSize + scope.$index + 1}}</template>
        </el-table-column>

        <el-table-column label="标题" prop="title" width="130px" align="center"></el-table-column>
        <el-table-column label="频道" prop="channelName" align="center"></el-table-column>
        <el-table-column label="分享者" prop="shareName" align="center"></el-table-column>
        <el-table-column label="来源" prop="source" align="center"></el-table-column>
        <el-table-column label="投稿人昵称" prop="userName" align="center"></el-table-column>
        <el-table-column label="投稿时间" prop="createTime" align="center" width="200"></el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="scope" >
            {{scope.row.status == 1 ? '待审核' : scope.row.status == 2 ? '已发布' : scope.row.status == 3 ? '已驳回' :''}}
          </template>
        </el-table-column>
        <el-table-column label="审核时间" prop="updateTime" align="center" width="200"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes,prev, pager, next,jumper"
        :current-page.sync="listQuery.pageNum"
        :page-size="listQuery.pageSize"
        :page-sizes="[10,15,20]"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 评论内容 -->
    <el-dialog title="评论内容" width="65%" :visible.sync="dialogTableVisible">
      <el-table :data="commentList">
        <el-table-column property="userName" label="昵称" width="150" align="center"></el-table-column>
        <el-table-column label="头像" align="center">
          <template slot-scope="scope">
            <img style="width:100px;height:100px" :src="scope.row.headPic" alt srcset />
          </template>
        </el-table-column>
        <el-table-column property="content" label="内容" align="center"></el-table-column>
        <el-table-column property="createTime" label="时间" align="center"></el-table-column>
      </el-table>
      <div class="comment-container">
        <el-pagination
          background
          @size-change="handleCommentSizeChange"
          @current-change="handleCommentCurrentChange"
          layout="total, sizes,prev, pager, next,jumper"
          :current-page.sync="commentListQuery.pageNum"
          :page-size="commentListQuery.pageSize"
          :page-sizes="[10,15,20]"
          :total="commentTotal"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  get_hot_new_channel_list_all as getCannelList,
  getone,
  getpub as getAll
} from "@/api";

const defaultListQuery = {
  pageNum: 1,
  pageSize: 10,
  title: null,
  source: null,
  shareName: null,
};
const defaultCommentListQuery = {
  pageNum: 1,
  pageSize: 10,
};
export default {
  name: "adminList",
  data() {
    return {
      listQuery: Object.assign({}, defaultListQuery),
      commentListQuery: Object.assign({}, defaultCommentListQuery),
      list: null,
      total: null,
      commentTotal: null,
      listLoading: false,
      dialogFormVisible: false,
      formLabelWidth: "60px",
      form: {},
      dialogTableVisible: false,
      commentList: [],
      channelList: [],
      redactDialogFormVisible: false,
    };
  },
  created() {
    this.requsetNewList();
    // this.requestChannelList();
  },
  methods: {
    handleLogOut() {
      localStorage.removeItem('token')
      this.$router.replace('/')
    },
    //获取所有 频道列表
    requestChannelList() {
      getCannelList().then((res) => {
        //console.log(res);
        if (res.code == 200) {
          this.channelList = res.data;
        }
      });
    },
    requsetNewList() {
      let params = {
        ...this.listQuery,
      };
      console.log("请求参数",this.listQuery);
      this.listLoading = true;
      getAll(params).then((res) => {
        this.listLoading = false;
        if (res.code == 200) {
          //console.log(res);
          this.list = res.data.list;
          this.total = res.data.total;
          this.listQuery.pageSize = res.data.pageSize;
          this.listQuery.pageNum = res.data.pageNum;
        }
      });
    },
    // 保存
    requestSaveChannel(arr) {
      console.log(arr);
      saveChannel(arr).then((res) => {
        //console.log(res);
      });
    },

    handleResetSearch() {
      this.listQuery = Object.assign({}, defaultListQuery);
    },
    handleSearchList() {
      this.listQuery.pageNum = 1;
      this.requsetNewList();
    },
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.requsetNewList();
    },
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.requsetNewList();
    },
    handleCommentSizeChange(val) {
      this.commentListQuery.pageNum = 1;
      this.commentListQuery.pageSize = val;
      this.requestSelectComment();
    },
    handleCommentCurrentChange(val) {
      this.commentListQuery.pageNum = val;
      this.requestSelectComment();
    },
    handleAdd() {
      this.$router.push('Contribution');
    },
    handleRemoveClick(pubLogId) {
      console.log(pubLogId);
      this.$confirm("确认要驳回吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log("请求驳回");
          this.requsetCheckFail(pubLogId);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消驳回",
          });
        });
    },
    handeleSaveClick() {
      console.log("11");
      let arr = [
        {
          name: this.form.name1,
          language: 1, //1：中文  2：英文 3：德文 4：日文
        },
        {
          name: this.form.name2,
          language: 2,
        },
        {
          name: this.form.name3,
          language: 3,
        },
        {
          name: this.form.name4,
          language: 4,
        },
      ];
      console.log(arr);
      let newArr = [];
      arr.forEach((item, index) => {
        if (item.name) {
          newArr[index] = {
            name: item.name,
            language: item.language,
          };
        }
      });
      this.requestSaveChannel(JSON.stringify(newArr));
    },
    handeleRedactClick(id) {
      console.log("投稿id", id);
      this.$router.push({
        path: "check",
        query: {
          publishId: id,
        },
      });
    },
    requsetCheckFail(pubLogId) {
      console.log("请求驳回", pubLogId);
      check_fail(pubLogId).then((res) => {
        //console.log("111");
        ////console.log(res);
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "驳回成功!",
          });
          this.requsetNewList();
        }
      });
    },
  },
};
</script>
<style scoped>
.app-container {
  padding: 20px;
  box-sizing: border-box;
}
.comment-container {
  text-align: right;
  margin-top: 20px;
}

#cus-input .el-input {
  width: 167px;
}
</style>
<style>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
  margin-right: 10px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-icon--right {
  margin-left: 0;
}
.el-pagination {
  text-align: right;
  margin-top: 20px;
}
</style>


